// removed by extract-text-webpack-plugin
module.exports = {"btn-manage-recipients":"app-pages-AccountSetting-EmailNotification-EmailNotificationForm-__EmailNotificationForm___1cd2j"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/EmailNotificationForm.css
// module id = 2048
// module chunks = 0